<template>
  <v-menu bottom left class="" min-width="240" content-class="menu-component" color="transparent">
    <template v-slot:activator="{ on }">
      <v-btn
        text
        class="align-self-center menu-custom flex-grow-1 text--primary"
        color="transparent"
        v-on="on"
      >
        more
        <v-icon right>{{ icons.mdiMenuDown }}</v-icon>
      </v-btn>
    </template>

    <v-list class="lighten-3 menu-list">
      <v-list-item
        v-for="(item, i) in more"
        :key="i"
        class="menu-list-item text-sm"
        :style="{ background: item.key === $route.params.id ? '#f0f0f0' : '#ffffff' }"
        @click="$emit('addItem', item)"
      >
        <div class="d-flex justify-space-between w-full">
          <div class="">
            <v-icon :size="16" class="mr-2">
              {{ item.icon }}
            </v-icon>
            {{ item.title }}
          </div>
        </div>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import { mdiMenuDown, mdiClose } from '@mdi/js'
import { storeGetters, storeActions } from '@/store/storeConstants'
import store from '@/store'

export default {
  props: {
    more: {
      type: Array,
      default: () => {},
    },
  },
  setup(props, { emit }) {
    const closeTab = item => {
      store.commit('tabPersist/RESET_TOGGLE_DROPDOWN')
      store.dispatch(`tabs/${storeActions.CANCEL_TAB_REQUEST}`, item)
      emit('onResize')
    }

    return {
      closeTab,
      icons: {
        mdiMenuDown,
        mdiClose,
      },
    }
  },
}
</script>

<style></style>
